import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Box = styled.div`
  position: relative;
  width: 100%;
  input {
    border: none;
    border-bottom: solid 1px;
    direction: ${props => (props.alignLeft ? "ltr" : "rtl")};
    border-color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_500;
      }
    }};
    background: transparent;
    width: 100%;
    //padding: 12px 0; I feel this is to small ( in team edit)
    //padding: 16px 0 8px;
    padding: 16px 0 8px
    ${props => (props.paddingLeft ? props.paddingLeft + "px" : 0)};
    font-size: ${Variables.font_sizes.x2_medium};
    &:focus {
      box-shadow: none;
      outline: none;
      border-color: ${props => {
        switch (props.status) {
          case "warning":
            return Variables.colors.yellow_500;
          case "error":
            return Variables.colors.red_600;
          case "success":
            return Variables.colors.green;
          default:
            return Variables.colors.primary_vivid;
        }
      }};
    }
  }
  i {
    position: absolute;
    left: 0;
    top: 12px;
    font-size: 20px;
    margin-left: 20px;
    color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          if (props.iconStatus === "focus") {
            return Variables.colors.primary_vivid;
          } else {
            return Variables.colors.complementary_500;
          }
      }
    }};
  }
  .notice {
    margin-bottom: 8px;
    display: block;
    padding: 4px 0;
    font-size: ${Variables.font_sizes.x_small};
    color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_500;
      }
    }};
  }
  label {
    position: absolute;
    top: 12px;
    right: 0;
    font-size: ${Variables.font_sizes.x2_large};
    color: ${Variables.colors.complementary_500};
    transition: 0.1s;
    cursor: text;
    z-index: -1;
    ${props => {
      if (props.labelStatus === "top") {
        return `
            top: 0;
            font-size: ${Variables.font_sizes.small};
            cursor: default;
            `;
      }
    }}
  }
`;
